import * as React from 'react';
import HeaderMenu from './components/menu/HeaderMenu';
import { Col, Layout, Row } from 'antd';
import SearchBox from './SearchBox';
import { Link } from 'react-router-dom';
import SiteHeader from './components/site_header/SiteHeader';
const { Header: AntDHeader } = Layout;

function Header({
  useLogo = false,
  headerExpandClass,
  isLoggedInState,
  loadingState,
  triggerRedirect,
  usesFixedMobileView = false,
  hideOnMobile = false,
  useMaxWidth = false,
  isUserProfile = false,
  isHome = false,
  isEventSignUp = false,
}) {
  if (isHome) {
    return (
      <SiteHeader
        isLoggedInState={isLoggedInState}
        loadingState={loadingState}
      />
    );
  }

  return (
    <AntDHeader
      id={'fixed-header'}
      className={
        headerExpandClass +
        ' header ' +
        (useMaxWidth ? 'main_container_padding ' : '') +
        (hideOnMobile ? 'header-md ' : '') +
        (isUserProfile && 'custom-header-styles')
      }
    >
      <Row
        justify='space-between'
        className={useMaxWidth ? 'main_container_padding__content ' : ''}
      >
        <Col
          id='sb-header-logo-col'
          className='gutter-row sb-align-left'
          xs={isEventSignUp ? 6 : 0}
          sm={6}
          md={7}
          lg={9}
        >
          <Link to={'/'}>
            {useLogo ? (
              <img
                alt='swimbooker logo'
                id='home-logo'
                src={
                  process.env.PUBLIC_URL +
                  '/assets/Logos/swimbooker_logo_no_icon.png'
                }
              />
            ) : (
              <p className='white fs-22 gSemiBold'>swimbooker</p>
            )}
          </Link>
        </Col>
        {!isEventSignUp && (
          <Col
            id={'sb-header-search-wrapper'}
            className='gutter-row '
            xs={12}
            sm={12}
            md={10}
            lg={9}
          >
            <SearchBox />
          </Col>
        )}
        <Col
          className='gutter-row sb-align-right'
          id='sb-header-menu-col'
          xs={6}
          sm={6}
          md={7}
          lg={6}
        >
          <HeaderMenu
            usesFixedMobileView={usesFixedMobileView}
            isLoggedInState={isLoggedInState}
            loadingState={loadingState}
            triggerRedirect={triggerRedirect}
          />
        </Col>
      </Row>
    </AntDHeader>
  );
}

export default Header;
